import React, { Fragment } from 'react';

/** Components */
import {
  StyleIconWidget,
  StyledText,
  StyleWrapResult,
  StyledTemp,
  StyledTempMaxMin,
  StyledDescription,
  StyledStatus
} from './style';
import WidgetMiniUpdate from '../../../../core/WidgetMini/WidgetMiniUpdate';

/** Utils */
import { selectIcon } from '../../../../../constants/weatherIcons';

const WeatherInfo = ({
  icon,
  temp,
  tempMax,
  tempMin,
  description,
  name,
  lastUpdate,
  getWeather
}) => (
  <Fragment>
    <StyledText className="WeatherInfo-name">{name}</StyledText>
    <StyleWrapResult>
      <StyledStatus>
        <StyleIconWidget svg={selectIcon(icon)} size="l" color="dark" />
        <StyledDescription title={description}>
          {description.charAt(0).toUpperCase() + description.slice(1)}
        </StyledDescription>
      </StyledStatus>
      <StyledTemp>
        {`${Math.round(temp)}º`}
        <StyledTempMaxMin>
          {`${Math.round(tempMax)}º`} | {`${Math.round(tempMin)}º`}
        </StyledTempMaxMin>
      </StyledTemp>
    </StyleWrapResult>
    <WidgetMiniUpdate update={lastUpdate} onInfo={getWeather} />
  </Fragment>
);

export default WeatherInfo;
